// Product Grid Image Slider Navigation
function initProductGridSliders() {
  const sliders = document.querySelectorAll('.product-images-slider');
  
  sliders.forEach(slider => {
    // Skip if already initialized
    if (slider.dataset.sliderInitialized === 'true') return;
    
    const wrapper = slider.closest('.product-images-slider-wrapper');
    if (!wrapper) return;
    
    const prevBtn = wrapper.querySelector('.slider-arrow-prev');
    const nextBtn = wrapper.querySelector('.slider-arrow-next');
    const totalItems = parseInt(slider.dataset.sliderItems) || 1;
    
    if (!prevBtn || !nextBtn || totalItems <= 1) return;
    
    // Update arrow states based on scroll position
    function updateArrows() {
      const scrollLeft = slider.scrollLeft;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      
      // Left arrow - disabled at start
      if (scrollLeft <= 1) {
        prevBtn.classList.add('disabled');
      } else {
        prevBtn.classList.remove('disabled');
      }
      
      // Right arrow - disabled at end
      if (scrollLeft >= maxScroll - 1) {
        nextBtn.classList.add('disabled');
      } else {
        nextBtn.classList.remove('disabled');
      }
    }
    
    // Navigate to next/prev slide
    function navigateSlider(direction) {
      const slideWidth = slider.clientWidth;
      const currentScroll = slider.scrollLeft;
      const targetScroll = direction === 'next' 
        ? currentScroll + slideWidth 
        : currentScroll - slideWidth;
      
      slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
    
    // Event listeners
    const handlePrevClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!prevBtn.classList.contains('disabled')) {
        navigateSlider('prev');
      }
    };
    
    const handleNextClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (!nextBtn.classList.contains('disabled')) {
        navigateSlider('next');
      }
    };
    
    prevBtn.addEventListener('click', handlePrevClick);
    nextBtn.addEventListener('click', handleNextClick);
    
    // Update arrows on scroll
    slider.addEventListener('scroll', updateArrows);
    
    // Initialize arrow states
    updateArrows();
    
    // Mark as initialized
    slider.dataset.sliderInitialized = 'true';
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initProductGridSliders);

// Make function globally available for Ajaxinate and filter callbacks
window.initProductGridSliders = initProductGridSliders;
